import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  private readonly handleDialogCloseBound = this.handleDialogClose.bind(this)

  connect (): void {
    this.dialog?.addEventListener('close', this.handleDialogCloseBound)
  }

  disconnect (): void {
    this.dialog?.removeEventListener('close', this.handleDialogCloseBound)
  }

  handleSubmit (event: CustomEvent): void {
    const { detail } = event as CustomEvent<{ success: boolean }>

    if (detail.success) {
      this.closeSlideover()
    }
  }

  handleCancel (): void {
    this.closeSlideover()
  }

  private handleDialogClose (): void {
    this.dispatchReopen()
  }

  private closeSlideover (): void {
    const controller = this.getSlideoverController()

    if (controller !== null && typeof (controller as { close?: () => void }).close === 'function') {
      (controller as { close: () => void }).close()
      return
    }

    this.dialog?.close()
  }

  private dispatchReopen (): void {
    document.dispatchEvent(new CustomEvent('respond-slideover:reopen', { bubbles: true }))
  }

  private get slideoverElement (): HTMLElement | null {
    return this.element.closest('[data-controller~="slideover"]')
  }

  private get dialog (): HTMLDialogElement | null {
    return this.slideoverElement?.querySelector('[data-slideover-target="dialog"]') as HTMLDialogElement | null
  }

  private getSlideoverController (): any {
    const element = this.slideoverElement
    if (element == null) return null

    const application: any = this.application
    return application?.getControllerForElementAndIdentifier?.(element, 'slideover') ?? null
  }
}
